export var OVERLAY_TIMEOUT = 150;
export var MODAL_VARIANT = {
    BOTTOM: 'bottom',
    CENTER: 'center',
};
